import { queryKeys } from '../constants';
import { useQueryWithLogging } from '../useQueryWithLogging';
import Service from '@/lib/App';

export function useGetApprovers(
  { techFamilies }: { techFamilies: string[] },
  options?: { enabled: boolean },
) {
  const uniqueTechFamilies = [...new Set(techFamilies)].sort();
  return useQueryWithLogging({
    queryKey: queryKeys.planner.approvers(uniqueTechFamilies),
    queryFn: () =>
      Service.planner.getTechFamilyApprovers({
        tech_family: uniqueTechFamilies,
      }),
    ...options,
  });
}
